import axios from "axios";
import { BASE_ENDPOINT } from "../helpers/Config";

const TRADE_HISTORY_URL = `${BASE_ENDPOINT}/admin/trade-history`;
const TRADE_LIST_URL = `${BASE_ENDPOINT}/admin/trade-list`;

/**
 * POST /admin/trade-history
 * @param {import("../types/tradeHistory").TradeHistoryParams} params
 */
export async function fetchTradeHistory(params) {
    const res = await axios({
        method: "post",
        url: TRADE_HISTORY_URL,
        headers: { "Content-Type": "application/json" },
        data: {
            token: params.token,
            from_date: params.from_date,
            to_date: params.to_date,
            period: params.period ?? "",
            entity_id: params.entity_id ?? "",
            search: params.search ?? "",
            status: params.status ?? "",
            page_no: params.page_no ?? 1,
            limit: Math.min(100, Math.max(1, params.limit ?? 20)),
        },
    });
    return res?.data;
}

/**
 * POST /admin/trade-list — entity dropdown options
 * @param {string} token
 */
export async function fetchTradeListEntities(token) {
    const res = await axios({
        method: "post",
        url: TRADE_LIST_URL,
        headers: { "Content-Type": "application/json" },
        data: { token },
    });
    return res?.data;
}
